import { ActionButtonsComponent } from "./ActionButtons";
import { TitleComponent } from "./Title";

export function ModalComponent() {
  return <></>;
}

ModalComponent.Title = TitleComponent;
ModalComponent.ActionButtons = ActionButtonsComponent;
